import {H1} from '@hm/fundamental'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {Outlet, useLocation, useNavigate} from 'react-router'

import {useUrlParam, useUrlParamOptional} from '@refra/modules/routing/hooks'

export const StaticPartReplacementEdit = () => {
  const navigate = useNavigate()
  const plantCode = useUrlParam('plantCode')
  const staticPartId = useUrlParam('staticPartId')
  const selectedKilnId = useUrlParam('selectedKilnId')
  const componentId = useUrlParamOptional('componentId')
  const shutdownId = useUrlParamOptional('shutdownId')
  const location = useLocation()
  const {t} = useTranslation()

  const staticPartDetailUrl = `/plants/${plantCode}/static-parts/${selectedKilnId}/${staticPartId}`

  useEffect(() => {
    if (!componentId || (!shutdownId && !location.pathname.endsWith('edit'))) {
      void navigate(`${staticPartDetailUrl}/edit`, {
        replace: true
      })
    }
  }, [componentId, location.pathname, navigate, shutdownId, staticPartDetailUrl])

  return (
    <div>
      <div className="flex justify-between items-center">
        <H1 className="my-6 ml-6 max-w-400px">{t('staticParts.editReplacement.title')}</H1>
      </div>
      <Outlet />
    </div>
  )
}
